import PropTypes from 'prop-types';
import { broadcast } from '../../../shared/event';

const asButton = (id, event, handler, ...args) =>
  (id || event) && {
    role: 'button',
    type: 'button',
    onClick: (e) => {
      e.stopPropagation();
      broadcast(event || id, 'click', e, ...args);
      if (handler) {
        handler(e, ...args);
      }
    }
  };

asButton.propTypes = {
  id: PropTypes.string.isRequired,
  event: PropTypes.string.isRequired,
  handler: PropTypes.func
};

asButton.defaultProps = {
  handler: () => {}
};

export default asButton;
